export default __webpack_public_path__ + "static/KeywordResearch_02_02@2x-9f4f58c6ff4c525d89471ff0bc6db06e.webp";